import { render } from "./NewBookSubmitForm.vue?vue&type=template&id=5557ec13&scoped=true"
import script from "./NewBookSubmitForm.vue?vue&type=script&lang=js"
export * from "./NewBookSubmitForm.vue?vue&type=script&lang=js"

import "./NewBookSubmitForm.vue?vue&type=style&index=0&id=5557ec13&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5557ec13"]])

export default __exports__